import { SelectProps } from "antd";
import { TipoDestinoEnum } from "core/features/documentos/enums";
import SelectBaseAntd from "../SelectBaseAntd";

export interface SelectTipoDestinoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
  showEmail?: boolean;
  showPessoa?: boolean;
  showCargo?: boolean;
  showTodasUnidades?: boolean;
  showGrupoUnidades?: boolean;
  showUmaUnidade?: boolean;
}

function SelectTipoDestino({
  onChange,
  value,
  isInvalid,
  showEmail = true,
  showPessoa = false,
  showCargo = false,
  showTodasUnidades = true,
  ...rest
}: SelectTipoDestinoProps) {
  const options = [
    {
      label: "Um grupo de unidades",
      value: TipoDestinoEnum.UmGrupoUnidades,
    },
    {
      label: "Uma unidade",
      value: TipoDestinoEnum.UmaUnidade,
    },
  ];

  if (showTodasUnidades) {
    options.push({
      label: "Todas as unidades",
      value: TipoDestinoEnum.TodasUnidades,
    });
  }

  if (showEmail) {
    options.push({
      label: "Email",
      value: TipoDestinoEnum.Email,
    });
  }

  if (showPessoa) {
    options.push({
      label: "Uma pessoa",
      value: TipoDestinoEnum.UmaPessoa,
    });
  }

  if (showCargo) {
    options.push({
      label: "Um cargo",
      value: TipoDestinoEnum.UmCargo,
    });
  }

  return (
    <SelectBaseAntd
      onChange={onChange}
      placeholder="-- Selecione --"
      value={value}
      isInvalid={isInvalid}
      size="large"
      {...rest}
      options={options}
    />
  );
}

export default SelectTipoDestino;
